export const setupNotices = () => {
  const closeNotices = document.querySelectorAll(".close-notice");
  closeNotices.forEach((x) => {
    x.addEventListener("click", (e) => {
      const { parentElement } = e.currentTarget;
      parentElement.classList.add("is-hidden");
    });
  });

  document.addEventListener("showAlert", (e) => {
    const noticeContainer = document.querySelector(".notice");
    if (noticeContainer) {
      noticeContainer.classList.remove("is-hidden");
      noticeContainer.classList.add("notice--alert");
      noticeContainer.querySelector("p").textContent = e.detail;
      noticeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  document.addEventListener("showNotice", (e) => {
    const noticeContainer = document.querySelector(".notice");
    if (noticeContainer) {
      noticeContainer.classList.remove("is-hidden");
      noticeContainer.classList.remove("notice--alert");
      noticeContainer.querySelector("p").textContent = e.detail;
      noticeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  document.addEventListener("hideNotice", () => {
    const noticeContainer = document.querySelector(".notice");
    if (noticeContainer) {
      noticeContainer.classList.add("is-hidden");
    }
  });
};
